import { gql } from '@apollo/client'

export interface IGetDiscountItemTypesVariableTypes {
  iStartDate: string
  iEndDate: string
  iFilter: any
}

export interface IDiscountItemNodeType {
  id: number
  itemType: string
  catogories: string
}

export interface IGetDiscountItemTypesType {
  getMarketingAnalysisItems: {
    nodes: IDiscountItemNodeType[]
  }
}

export const GET_MARKETING_ANALYSIS_ITEMS = gql`
  query GetMarketingAnalysisItems(
    $iStartDate: Date!
    $iEndDate: Date!
    $iFilter: JSON!
  ) {
    getMarketingAnalysisItems(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: $iFilter
    ) {
      nodes {
        id
        itemType
        catogories
      }
    }
  }
`

export const LIST_LOCATION_MARKET_ANALYSIS_DETAILS = gql`
  query ListLocationMarketAnalysisDetails(
    $iStartDate: Date!
    $iEndDate: Date!
    $iFilter: JSON!
  ) {
    listLocationMarketAnalysisDetails(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: $iFilter
    ) {
      nodes {
        locationInfo {
          id
          code
          name
        }
        totalComps
        totalCompsCount
        compsItemDetails
      }
    }
  }
`

export const LIST_LOCATION_GROUP_MARKET_ANALYSIS_DETAILS = gql`
  query ListLocationGroupMarketAnalysisDetails(
    $iStartDate: Date!
    $iEndDate: Date!
    $iFilter: JSON!
  ) {
    listLocationGroupMarketAnalysisDetails(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: $iFilter
    ) {
      nodes {
        locationGroupId
        locationGroupName
        startDate
        endDate
        totalCount
        totalAmount
        compsDetails
      }
    }
  }
`
